/**
 * BadgeToastListener — listens for badge-awarded events and shows a toast
 */
import { useEffect } from 'react';
import { useToast } from './ToastContext';
import BadgeIcon from './BadgeIcon';

const BadgeToastListener = () => {
  const { addToast } = useToast();

  useEffect(() => {
    const handler = (e) => {
      const { name, icon } = e.detail;
      addToast({
        message: <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}><BadgeIcon name={icon} size={20} /> Badge earned: {name}</span>,
        type: 'success',
        duration: 5000,
      });
    };

    window.addEventListener('badge-awarded', handler);
    return () => window.removeEventListener('badge-awarded', handler);
  }, [addToast]);

  return null;
};

export default BadgeToastListener;
